<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <pxkeji-btn
        name="添加"
        class="pxkeji_basic_btn"
        v-btnlimit="'资讯类型-添加'"
        @click="showInfo({'id':0})"
        type="primary"
      />
      <pxkeji-btn
        name="批量启用"
        @click="batchEnable"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
      />
      <pxkeji-btn
        name="批量禁用"
        @click="batchDisEnable"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
      />

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="status" slot-scope="status">
          <a-tag v-if="status" color="green">已启用</a-tag>
          <a-tag v-else color="red">已禁用</a-tag>
        </span>

        <span slot="action" slot-scope="action">
          <pxkeji-btn name="编辑" @click="showInfo(action)" size="small" type="primary" v-btnlimit="'资讯类型-编辑'"/>
          <a-divider type="vertical" />
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <pxkeji-btn
                  name="禁用"
                  @click="handleProhibit(action.id,0)"
                  v-btnlimit="'资讯类型-启用禁用'"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  v-if="action.status==1"
                />
                <pxkeji-btn
                  name="启用"
                  v-btnlimit="'资讯类型-启用禁用'"
                  @click="handleProhibit(action.id,1)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  v-else
                />
              </a-menu-item>
              <a-menu-item key="2">
                <pxkeji-btn
                  name="删除"
                  v-btnlimit="'资讯类型-删除'"
                  @click="delInfo(action.id)"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                />
              </a-menu-item>
                 <a-menu-item >
                <pxkeji-btn
                        name="上移"
                        v-btnlimit="'资讯类型-上移'"
                        @click="handlemoveup(action.id)"
                        size="small"
                        type="default"
                        class="pxkeji_dro_btn"
                />
              </a-menu-item>
               <a-menu-item >
                <pxkeji-btn
                        name="下移"
                        v-btnlimit="'资讯类型-下移'"
                        @click="handlemovedown(action.id)"
                        size="small"
                        type="default"
                        class="pxkeji_dro_btn"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed" v-btnlimit="'资讯类型-更多'">
              更多
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="60%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :infos="addedit.info" />
    </a-modal>
  </div>
</template>
<script>
import Info from "./articleTypeInfo.vue"; //编辑

const columns = [
  // {
  //   dataIndex: "id",
  //   key: "id",
  //   align: "center",
  //   title: "编号"
  // },
  {
    dataIndex: "name",
    key: "name",
    align: "left",
    title: "类型名称"
  },
  {
    dataIndex: "description",
    key: "description",
    align: "center",
    title: "备注"
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

var that;
export default {
  name: "articleTypelist",
  data() {
    return {
      treeData: [],
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          number: "",
          status: ""
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      }
    };
  },
  components: {
    Info
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.getTree();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    /**上移下移 */
    handlemoveup(id,) {
      this.isloading = true;
      this.$api.articlecategory
              .sortData(id,1)
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  that.$message.success(res.errorMsg);
                  this.getTree()
                } else {
                  that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });

    },
    handlemovedown(id) {
      this.isloading = true;
      this.$api.articlecategory
              .sortData(id,0)
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  that.$message.success(res.errorMsg);
                  this.getTree()
                } else {
                  that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
    },
    buildTree(all,parentid){
        var list=[];
        for(var i=0;i<all.length;++i){
          var item=all[i];
          
          if(item.parentid==parentid){
            var childs=this.buildTree(all,item.id);
            list.push({
                name: item.name,
                parentid: parentid,
                id: item.id,
                description:item.description,
                status:item.isshow,
                children: childs
            });
          }
        }
        return list;
    },
    getTree() {
      this.$api.articlecategory
        .getAll(this.id)
        .then(res => {
          if (res.errorCode == this.$msg.responseCode.success) {
            var list=this.buildTree(res.data,0);
            this.list.datas = list;
            this.list.pagination.total = list.length;
            
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
   
    showInfo(info) {
      
      this.addedit.visible = true;
      this.addedit.title = info.id ? "编辑" : "新增";
      this.addedit.info = info;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      that.handleProhibit(that.selectRows.join(","), 0);
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      if (!status) {
        this.$confirm({
          title: "提示",
          content: "您确定要禁用么",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            that.isDisable(ids, status);
          },
          onCancel() {}
        });
      } else {
        that.isDisable(ids, status);
      }
    },
    /**禁用启用的方法 */
    isDisable(ids, status) {
      that.isloading = true;
      that.$api.articlecategory
        .updateStatus(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetTree();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.articlecategory
            .del(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetTree();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    showInfoSupply() {
      //打开弹出框
      this.visibleSupply = true;
    },
    //子组件传值
    save() {
      this.addedit.visible = false;
      this.GetTree();
    },
    close() {
      this.$confirm({
        title: "提示",
        content: "您确定要禁用么",
        okText: "确认",
        cancelText: "取消"
      });
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

